<template>
  <div>
    <Head title="廣告橫幅設定" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <ad-template>
      <div class="w-full flex flex-row items-center justify-end gap-4">
        <Button label="新增" @click="addAd" />
        <!-- v-if="!isEditing" -->
        <!-- <Button
        v-if="!isEditing"
        label="順序及層次調整"
        class="p-button-outlined"
      />
      <Button v-if="isEditing" label="取消" class="p-button-outlined" /> -->
        <Button label="儲存" @click="saveAd" />
      </div>

      <div class="w-full pt-3">
        <Draggable v-bind="dragOptions" :list="ads" :group="{ name: 'ad' }">
          <div
            :key="getItemKey(ad)"
            v-for="(ad, index) in ads"
            class="w-full item cursor-move"
          >
            <div v-if="ad.image" class="max-w-[1000px] item">
              <img :src="'/storage/ad-images/' + ad.image + '/1000.jpg'" />
            </div>
            <div v-else class="max-w-[1000px] item">
              <BlockUI :blocked="isUploading">
                <FileUpload
                  mode="basic"
                  :auto="true"
                  name="images[]"
                  :url="route('admin.upload_ad')"
                  :multiple="false"
                  accept="image/*"
                  chooseLabel="選取檔案"
                  uploadLabel="上傳圖片"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  invalidFileTypeMessage="{0}：檔案格式錯誤，僅接受圖片格式檔案。"
                  @before-send="beforeUpload"
                  @upload="afterUpload($event, ad)"
                  @error="uploadError"
                >
                  <template #empty>
                    <p>將圖片拖曳至此上傳</p>
                  </template>
                </FileUpload>
              </BlockUI>
            </div>
            <div class="flex flex-row jusitfy-between items-begin gap-2">
              <div>
                <div class="mt-1">
                  <label :for="'fit_' + getItemKey(ad)">縮放</label>
                </div>
                <div class="mt-1">
                  <InputSwitch :id="'fit_' + getItemKey(ad)" v-model="ad.fit" />
                </div>
              </div>
              <div>
                <div class="mt-1">
                  <label :for="'group_' + getItemKey(ad)">群組</label>
                </div>
                <div class="mt-1">
                  <InputText
                    style="width: 100px"
                    :id="'group_' + getItemKey(ad)"
                    v-model="ad.group"
                  />
                </div>
              </div>
              <div>
                <div class="mt-1">
                  <label :for="'link_' + getItemKey(ad)">連結</label>
                </div>
                <div class="mt-1">
                  <div>
                    <InputText
                      style="width: 600px"
                      :id="'link_' + getItemKey(ad)"
                      v-model="ad.link"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="mt-1">
                  <label :for="'del_' + getItemKey(ad)">刪除</label>
                </div>
                <div class="mt-1">
                  <div>
                    <Button
                      class="p-button-danger"
                      :id="'del_' + getItemKey(ad)"
                      label="刪除"
                      @click="delAd(ad, index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    </ad-template>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import AdTemplate from "./Shared/AdTemplate";
import Button from "primevue/button";
import Draggable from "vuedraggable";
import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import BlockUI from "primevue/blockui";
import FileUpload from "primevue/fileupload";

export default {
  components: {
    ScrollTop,
    Breadcrumb,
    AdTemplate,
    Button,
    Draggable,
    InputText,
    InputSwitch,
    BlockUI,
    FileUpload,
  },
  layout: Layout,
  computed: {
    dragOptions() {
      return {
        animation: 0,
        // disabled: !this.isEditing,
        ghostClass: "current_destination",
      };
    },
  },
  data() {
    return {
      breadcrumb_home: {
        label: "頁面管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "廣告橫幅設定",
          to: route("admin.ad"),
          disabled: !decodeURI(this.$page.url).includes("group"),
        },
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],
      isUploading: false,
      isEditing: false,
      ads: this.$page.props.ads ?? [],
      ads_del: [],
    };
  },
  methods: {
    getItemKey(item) {
      if (item.id == null) return item.random;
      else return item.id;
    },
    addAd() {
      this.ads.unshift({
        id: null,
        group: null,
        random: Math.random().toString(36).substring(2),
        image: null,
        link: null,
        fit: false,
      });
    },
    saveAd() {
      this.ads = this.ads.filter((ad) => {
        return ad.image != null;
      });

      this.ads_del = this.ads_del.filter((ad) => {
        return ad.image != null || ad.id == null;
      });

      this.$inertia.post(
        route("admin.ad.save"),
        {
          ads: this.ads,
          ads_del: this.ads_del,
        },
        {
          only: ["ads", "groups", "flash"],
          onSuccess: (page) => {
            this.ads = page.props.ads;
            this.ads_del = [];
          },
        }
      );
    },
    delAd(ad, index) {
      this.ads_del.push(ad);
      this.ads.splice(index, 1);
    },
    beforeUpload(request) {
      this.isUploading = true;
      request.xhr.setRequestHeader("X-CSRF-TOKEN", this.$page.props.csrf_token);
      return request;
    },
    afterUpload(event, item) {
      item.image = JSON.parse(event.xhr.response)[0];
      this.isUploading = false;
    },
    uploadError(event) {
      this.isUploading = false;
      console.error(event);
    },
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

.item {
  @apply relative border rounded border-fh-gray-light p-2 mb-2;
}
</style>

<style>
.current_destination {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>